<template>
    <tw-modal
        ref="modal"
    >
        <template v-slot:content>
            <div
                v-if="success"
                class="p-4 bg-green-100 rounded-md"
                role="alert"
            >
                <div class="flex">
                    <div class="flex-shrink-0">
                        <!-- Heroicon name: solid/check-circle -->
                        <svg class="w-6 h-6 text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                        </svg>
                    </div>
                    <div class="ml-3">
                        <p class="text-sm font-medium text-green-900">
                            Success!
                        </p>
                    </div>
                </div>
            </div>

            <div
                class="w-full px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4"
            >
                <div class="w-full sm:flex sm:items-start">
                    <svg xmlns="http://www.w3.org/2000/svg"
                        class="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto text-blue-500 rounded-full sm:h-8 sm:mx-0 sm:w-8"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                    >
                        <path stroke-linecap="round" stroke-linejoin="round" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
                    </svg>
                    <div class="w-full mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <h3 class="text-lg font-medium leading-6 text-gray-900" id="modal-title">
                            {{ modalTitle }}
                        </h3>
                        <div v-if="success" class="p-4 mt-4 text-md">
                            <p>{{ successMessage }}</p>
                        </div>
                        <div v-else class="mt-2">
                            <ul>
                                <li
                                    class="text-sm text-red-600"
                                    :class="{'hidden': !errorMessages.length}"
                                    v-for="(error, index) in errorMessages"
                                    :key=index
                                >
                                    {{ error }}
                                </li>
                            </ul>
                            <div class="mt-4">
                                <label for="notes" class="block text-sm text-gray-500">Notes</label>
                                <div class="mt-1">
                                    <textarea v-model="form.notes" rows="4" name="notes" id="notes" class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="flex justify-between px-4 py-3 space-x-2 sm:space-x-4 bg-gray-50 sm:px-6"
            >
                <a
                    v-if="success"
                    class="tw-button-gray"
                    @click="closeModal"
                >Close</a>
                <a
                    v-else
                    class="tw-button-gray"
                    @click="closeModal"
                >{{ trans('app.cancel').titleCase() }}</a>
                <button
                    v-if="!success"
                    type="button"
                    class="tw-button-green space-x-1.5"
                    @click="submit"
                    :disabled="loading"
                >
                    <span>{{ trans('app.submit').titleCase() }}</span>
                    <svg
                        v-if="loading"
                        class="w-5 h-5 animate-spin"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                        </path>
                    </svg>
                </button>
            </div>
        </template>
    </tw-modal>
</template>

<script>
import Form from 'form-backend-validation';

export default {
    data () {
        return {
            form: new Form({
                model_id: null,
                model_type: null,
                attribute: '',
                notes: '',
                can_see_attribute: false,
            }),
            attributeTitle: '',
            errorMessages: {},
            successMessage: null,
            success: false,
            loading: false,
        };
    },
    listeners: {
        'open-profile-data-request-modal' (modelType, modelId, attributeName, attributeTitle, canSeeAttribute) {
            this.form.model_id = modelId;
            this.form.model_type = modelType;
            this.form.attribute = attributeName;
            this.attributeTitle = attributeTitle;
            this.form.can_see_attribute = canSeeAttribute;
            this.showModal();
        },
    },
    computed: {
        modalTitle () {
            return this.trans('app.profile_data.request.attribute', { attribute: this.attributeTitle }).titleCase();
        },
    },
    methods: {
        showModal () {
            this.$refs.modal.show();
        },
        closeModal () {
            this.$refs.modal.hide();
            this.errorMessages = {};
            this.successMessage = null;
            this.success = false;
            this.form.reset();
        },
        async submit () {
            this.loading = true;
            this.errorMessages = {};
            axios.post(this.route('data_requests.store'), this.form)
                .then((response) => {
                    this.success = true;
                    this.successMessage = response.data.message;
                })
                .catch((error) => {
                    this.errorMessages = [error.response.data.message];
                })
                .then(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
